<template>
  <div class="sn-f-col-b-c record">
    <div class="sn-f-s-0 sn-f-e-c sn-header-patient">
      <div class="sn-f-s-c region">
        <div class="sn-f-s-c patient-title">
          <div class="required">*</div>
          <div>就诊人：</div>
        </div>
        <div v-if="!$sn.validate.array(patientList)" @click="handlePatientInfo();">
          暂未获取到就诊人，<span class="sn-pointer sn-fc-main">点击刷新</span>
        </div>
        <div v-else-if="patientList.length === 0" @click="navigateUrl('addition-patient');">
          暂无就诊人，<span class="sn-pointer sn-fc-main">点击添加</span>
        </div>
        <template v-else>
          <el-select class="name" :value="selectedPatient.patientId" @change="sendBackPatient">
            <el-option :key="patient.patientId" :label="patient.patientName" :value="patient.patientId" v-for="patient in patientList"></el-option>
          </el-select>
        </template>
      </div>
      <div class="sn-f-s-c region" v-if="selectedPatient.patientId">
        <div class="sn-f-s-c patient-title">
          <div class="required">*</div>
          <div>{{ $sn.utils.getHospitalId() === perpetual.HOSPITAL_ID_SDSL ? '证件号' : '就诊卡' }}：</div>
        </div>
        <div v-if="!outCardSerial" @click="navigateUrl('addition-card');">
          {{ outCardSerialFormat }}，<span class="sn-pointer sn-fc-main">点击绑定</span>
        </div>
        <div v-else>
          <el-input class="card" readonly="readonly" v-model="outCardSerialFormat"></el-input>
        </div>
      </div>
      <div class="sn-f-s-c region">
        <div class="sn-f-s-c patient-title">
          <div class="required">*</div>
          <div>开单日期：</div>
        </div>
        <el-date-picker class="range"
        start-placeholder="开始日期" end-placeholder="结束日期" type="daterange"  value-format="yyyy-MM-dd"
        v-model="range" :editable="false" :clearable="false"></el-date-picker>
      </div>
      <div class="sn-f-c-c sn-pointer interaction"
      :class="{'sn-silence': !selectedPatient.patientId || !outCardSerial || range.length !== 2}" @click="getRecordInfo();">查询</div>
    </div>
    <div class="sn-f-1 record-region">
      <div class="sn-table" v-if="recordInfo.length > 0">
        <table>
          <thead>
            <tr>
              <th>序号</th>
              <th>检查项目</th>
              <th>检查科室</th>
              <th>预约日期</th>
              <th>预约时间</th>
              <th>预约状态</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr :key="record.regId" v-for="(record, i) in recordInfo">
              <td>{{ i + 1 }}</td>
              <td>{{ record.orderName }}</td>
              <td>{{ record.roomName }}</td>
              <td>{{ record.regDate }}</td>
              <td>{{ record.planTimeName }}</td>
              <td class="sn-fc-main">{{ record.statusDes }}</td>
              <td class="sn-pointer sn-fc-text3" @click="goCancel(record);">取消</td>
            </tr>
          </tbody>
        </table>
      </div>
      <sn-no-data v-else></sn-no-data>
    </div>
    <create-patient v-if="exhibitionCreatePatient" @sendBack="sendBackCreatePatient"></create-patient>
    <bind-card v-if="exhibitionBindCard" :patientId="selectedPatient.patientId || ''" @sendBack="sendBackBindCard"></bind-card>
  </div>
</template>
<script type="text/javascript">
import self from '@/common/utils/global-config';
import Swagger from '@/common/utils/swagger';
import HomepageMixin from '@/common/mixin/homepage-mixin';
import * as Messages from '@/common/utils/messages';
import * as Initial from '@/common/utils/initial';
import * as Tools from '@/common/utils/tools';
import * as ServiceConfig from '@/common/utils/service-config.js';

export default {
  components: {
    'create-patient': () => import('@/components/create-patient'),
    'bind-card': () => import('@/components/bind-card')
  },
  mixins: [HomepageMixin],
  data() {
    return {
      patientList: [],
      selectedPatient: {},
      outCardSerial: '',
      outCardSerialFormat: '',
      range: [
        self.$sn.format.date(self.$sn.utils.getCurrentTime(), 'yyyy-MM-dd', -1, 'month'),
        self.$sn.format.date(self.$sn.utils.getCurrentTime(), 'yyyy-MM-dd')
      ],
      recordInfo: [],
      //
      exhibitionCreatePatient: false,
      //
      exhibitionBindCard: false
    };
  },
  watch: {
    selectedPatient: async function(patient) {
      this.outCardSerial = '';
      this.outCardSerialFormat = '';
      this.recordInfo = [];
      if (patient.patientId) {
        this.$sn.assembly.loading(true);
        const handle = await Tools.handlePatientInfo(patient);
        this.$sn.assembly.loading(false);
        if (handle.code >= 0) {
          this.outCardSerial = handle.data.no;
          this.outCardSerialFormat = handle.data.caption;
          if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDSL && handle.code === 0) {
            this.outCardSerialFormat = patient.idCardEncrypt;
          }
        }
        if (!this.outCardSerial) {
          const compare = {
            [this.perpetual.HOSPITAL_ID_SDSL]: 'PATIENT043'
          };
          this.$sn.assembly.modal({
            caption: Messages[compare[this.$sn.utils.getHospitalId()] || 'RECHARGE012'],
            success: (modal) => {
              if (modal.confirm) {
                this.navigateUrl('addition-card');
              }
            }
          });
        }
      }
    },
    range: {
      handler: function() {
        this.recordInfo = [];
      },
      deep: true
    }
  },
  created: function() {
    this.handlePatientInfo();
  },
  methods: {
    async handlePatientInfo() {
      this.$sn.assembly.loading(true);
      await Initial.obtainPatientInfoByCondition();
      this.$sn.assembly.loading(false);
      this.patientList = this.$sn.utils.getHospitalLocalStorage('Login_PatientList');
      if (this.patientList && this.patientList.length > 0) {
        this.selectedPatient = this.$sn.utils.getCurrentPatient();
      }
    },
    getRecordInfo() {
      this.recordInfo = [];
      if (!this.selectedPatient.patientId || !this.outCardSerial || this.range.length !== 2) return false;
      this.$sn.assembly.loading(true);
      this.$sn.utils.ordinaryRequest({
        url: this.$sn.format.caption(Swagger.ordinaryTransmitLogin, [this.$sn.utils.getHospitalId(), 'f5e6ccb3-4da7-46a9-8418-d468c852aad7']),
        method: 'POST',
        header: true,
        data: this.$sn.utils.variableEncryption(this.$sn.format.xml({
          EndDate: this.range[1],
          PatId: this.selectedPatient.patientId,
          PlatformId: this.$sn.utils.getPlatformType(),
          PlatformUserId: this.$sn.utils.getOpenId(),
          StartDate: this.range[0]
        }))
      }, ServiceConfig.ordinaryTransmitLoginComplete).then(result => {
        this.$sn.assembly.loading(false);
        if (result) {
          if (result.code === 0) {
            if (result.data) {
              if (result.data.ResultCode === '0') {
                if (result.data.Data && result.data.Data.length > 0) {
                  this.recordInfo = result.data.Data;
                }
              }
              else {
                this.$sn.assembly.modal({
                  caption: result.data.ResultMsg,
                  isCancel: false
                });
              }
            }
          }
          else {
            this.$sn.assembly.modal({
              caption: result.msg,
              isCancel: false
            });
          }
        }
        else {
          this.$sn.assembly.modal({
            caption: Messages.C001,
            isCancel: false
          });
        }
      });
    },
    goCancel(record) {
      this.$sn.assembly.modal({
        caption: this.$sn.format.caption(Messages.C036, ['取消']),
        success: (modal) => {
          if (modal.confirm) {
            this.$sn.assembly.loading(true);
            this.$sn.utils.ordinaryRequest({
              url: this.$sn.format.caption(Swagger.ordinaryTransmitLogin, [this.$sn.utils.getHospitalId(), 'a938e550-6046-43a1-9f4f-77a1d47693d0']),
              method: 'POST',
              header: true,
              data: this.$sn.utils.variableEncryption(this.$sn.format.xml({
                PatId: this.selectedPatient.patientId,
                PlatformId: this.$sn.utils.getPlatformType(),
                PlatformUserId: this.$sn.utils.getOpenId(),
                RegId: record.regId
              }))
            }, ServiceConfig.ordinaryTransmitLoginComplete).then(result => {
              this.$sn.assembly.loading(false);
              if (result) {
                if (result.code === 0) {
                  if (result.data) {
                    if (result.data.ResultCode === '0') {
                      this.$sn.assembly.toast({
                        caption: this.$sn.format.caption(Messages.C016, ['取消']),
                        mode: 'success',
                        success: () => {
                          this.recordInfo = this.recordInfo.filter(res => res.regId !== record.regId);
                        }
                      });
                    }
                    else {
                      this.$sn.assembly.modal({
                        caption: result.data.ResultMsg,
                        isCancel: false
                      });
                    }
                  }
                  else {
                    this.$sn.assembly.modal({
                      caption: Messages.C002,
                      isCancel: false
                    });
                  }
                }
                else {
                  this.$sn.assembly.modal({
                    caption: result.msg,
                    isCancel: false
                  });
                }
              }
              else {
                this.$sn.assembly.modal({
                  caption: Messages.C001,
                  isCancel: false
                });
              }
            });
          }
        }
      });
    },
    sendBackPatient(id) {
      if (id) {
        this.selectedPatient = this.patientList.find(item => item.patientId === id);
        this.$sn.utils.setHospitalLocalStorage('CurrentPatient', this.selectedPatient);
      }
    },
    sendBackCreatePatient(type) {
      if (type) {
        this.patientList = this.$sn.utils.getHospitalLocalStorage('Login_PatientList');
      }
      this.exhibitionCreatePatient = false;
    },
    sendBackBindCard(type, patient) {
      if (type) {
        this.selectedPatient = patient;
        this.patientList = this.$sn.utils.getHospitalLocalStorage('Login_PatientList');
      }
      this.exhibitionBindCard = false;
    },
    navigateUrl(url, item, params, type = 'push') {
      if (this.$sn.validate.empty(url)) return false;
      if (url === 'addition-patient') {
        this.exhibitionCreatePatient = true;
      }
      else if (url === 'addition-card') {
        this.exhibitionBindCard = true;
      }
      else this.homepage_mixin_navigateUrl(url, item, params, type);
    }
  }
};
</script>
<style lang="scss" scoped>
.record {
  overflow: hidden;
  width: 100%;
  height: 100%;

  &-region {
    overflow: hidden;
    width: 100%;
  }
}
</style>
